import styled, { css } from 'styled-components';
import { white, black, maroon, primary, secondary } from 'constants/color';

export const StyledSubHeading = styled.h1`
  font-size: 12px;
`;

export const StyledCaption = styled.h3`
  color: ${black};
  font-size: 15px;
  margin: 5px 0 0 0;
`;

export const StyledButton = styled.button`
  border: none;
  font-size: 12px;
  cursor: pointer;
  color: #000000;
  padding: 5px 10px;
  border-radius: 20px;
  background: #d9d9d9;
  &:disabled {
    color: #5d5d5d;
    background: #d9d9d9;
    cursor: not-allowed;
  }
  svg {
    width: 15px;
    height: 15px;
    margin-left: 10px;
    vertical-align: sub;
  }
  ${function ({ $link }) {
    return (
      $link &&
      css`
        padding-left: 0;
        color: ${primary};
        background-color: ${white};
      `
    );
  }}
`;

export const StyledErrorLabel = styled.label`
  font-size: 12px;
  color: ${maroon};
  font-weight: 400;
`;

export const QuantityWrapper = styled.div`
  width: 100%;
  min-height: 1px;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;

  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 100%;
    padding-left: 0;
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
`;

export const QuantityButton = styled.button`
  top: 45px;
  right: 15px;
  height: 35px;
  border: none;
  display: flex;
  color: ${white};
  cursor: pointer;
  position: absolute;
  align-items: center;
  background: ${primary};
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  &:hover {
    background: ${secondary};
  }
`;
